const INPUT_TAGS = ['TEXTAREA', 'SELECT', 'INPUT'];

export function configureInputAwareStopCallback(hotKeysComponent) {
  const mousetrap = hotKeysComponent?.__mousetrap__;

  if (!mousetrap || mousetrap.__inputAwareStopCallback) {
    return;
  }

  mousetrap.stopCallback = (e, element) => {
    if ('composedPath' in e && typeof e.composedPath === 'function') {
      const pathTarget = e.composedPath()[0];

      if (pathTarget && pathTarget !== element) {
        element = pathTarget;
      }
    }

    return INPUT_TAGS.includes(element.tagName) || element.isContentEditable;
  };

  mousetrap.__inputAwareStopCallback = true;
}
